export default "__VITE_ASSET__B4y$B1qj__"